const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-sms/list.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SmsListFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-sms/list-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-sms/list')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SmsListFilterParamSchema
});